var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskPoligon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 53.134C24.5718 53.6699 23.4282 53.6699 22.5 53.134L2.11731 41.366C1.18911 40.8301 0.617312 39.8397 0.617312 38.768L0.61731 15.2321C0.61731 14.1603 1.18911 13.1699 2.11731 12.634L22.5 0.866027C23.4282 0.33013 24.5718 0.33013 25.5 0.866026L45.8827 12.634C46.8109 13.1699 47.3827 14.1603 47.3827 15.2321L47.3827 38.768C47.3827 39.8397 46.8109 40.8301 45.8827 41.366L25.5 53.134Z",
    fill: "#A90821"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskPoligon);
export default __webpack_public_path__ + "static/media/RiskPoligon.446f930d.svg";
export { ForwardRef as ReactComponent };